import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/'
    },
    {
        id: 2,
        title: 'About',
        link: '/about'
    },
    {
        id: 3,
        title: 'Our Services',
        link: '#',
        submenu: [
            {
                id: 31,
                title: 'Services ',
                link: '/services',
            },
            {
                id: 32,
                title: 'Domestic Transport',
                link: '/services/domestic-transport',
            },
            {
                id: 33,
                title: 'International Freight',
                link: '/services/international-freight',
            },
            {
                id: 34,
                title: 'Project Logistics',
                link: '/services/project-logistics',
            },
            {
                id: 35,
                title: 'Warehousing',
                link: '/services/warehousing',
            },
            {
                id: 36,
                title: 'Freight Consulting',
                link: '/services/freight-consulting',
            },
            {
                id: 37,
                title: 'Freight Management & Technology',
                link: '/services/freight-management-technology',
            },
            {
                id: 37,
                title: 'Cargo Insurance',
                link: '/services/cargo-insurance',
            },
            {
                id: 37,
                title: 'Removals Relocation',
                link: '/services/removals-relocation',
            },
           
        ]
    },

    {
        id: 4,
        title: 'Our Projects',
        link: '/project'
    },
    {
        id: 88,
        title: 'Contact',
        link: '/contact',
    }


]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p className='mb-0' onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu pb-0">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <NavLink onClick={ClickHandler} className="active"
                                                                    to={submenu.link}>{submenu.title}</NavLink>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <NavLink className="active"
                                        to={item.link}>{item.title}</NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;